// @flow

import React from "react";

import { ValidationMsg } from "../../messages/validation-messages";

import { Validation } from "../../model/validation";

type Item = {
  text: string,
  value: Object,
};

type Props = {
  inputId: string,
  wrapperCls?: string,
  inputCls?: string,
  type: string,
  name?: string,
  label?: string,
  placeholder?: string,
  value: string,
  valid?: Validation,
  items?: Item[],
  highlightedIndex?: number,
  autocomplete?: boolean | string,
  onChange: (e: Event, value: string) => void,
  onItemSelected?: (item: Item) => void,
  tealeafPIIValue?: "l" | "m" | "h",
};

export function FormInput(props: Props) {
  const clsWrapper = props.wrapperCls || "form-row";
  const cls = props.inputCls || "";
  const name = props.name || props.inputId;
  const inputType = getInputType(props.type);
  const labelAhead = inputType !== "checkbox";
  const tealeafPIIDataAttribute = props.tealeafPIIValue
    ? { pii: props.tealeafPIIValue }
    : {};
  return (
    <div className={`${clsWrapper}`}>
      {props.label && labelAhead && (
        <label
          dangerouslySetInnerHTML={{ __html: props.label }}
          htmlFor={props.inputId}
        />
      )}
      <div className="form-input">
        <input
          id={props.inputId}
          type={getInputType(props.type)}
          name={name}
          className={`${getInputValidationCls(props.valid)} ${cls}`}
          value={props.value}
          placeholder={props.placeholder}
          autoComplete={
            props.autocomplete === false ? "off" : props.autocomplete || "on"
          }
          onChange={(e) => {
            props.onChange(
              e,
              inputType === "checkbox" ? "" + e.target.checked : e.target.value
            );
          }}
          {...tealeafPIIDataAttribute}
        />
        {props.label && !labelAhead && (
          <label
            className="inline-label"
            dangerouslySetInnerHTML={{ __html: props.label }}
            htmlFor={props.inputId}
          />
        )}
        {props.items && props.items.length > 0 && (
          <div className="form-input-items">
            {props.items.map((item, i) => (
              <div
                className={`form-input-items__item ${
                  props.highlightedIndex === i
                    ? "form-input-items__item--active"
                    : ""
                }`}
                key={item.text}
                onClick={() =>
                  props.onItemSelected && props.onItemSelected(item)
                }
              >
                {item.text}
              </div>
            ))}
          </div>
        )}
        {props.valid && props.valid.success !== "" && (
          <i
            className={`validation-icon zmdi ${
              props.valid.success === "success" ? "zmdi-check" : "zmdi-close"
            }`}
          />
        )}
      </div>
      {props.valid &&
        props.valid.success === "fail" &&
        Object.keys(props.valid).map((k) => {
          if (k !== "success") {
            if (props.valid && props.valid[k] === true) {
              if (ValidationMsg[props.type][k]) {
                return (
                  <div
                    className={`form-error-msg form-error-msg__${props.inputId} form-error-msg__${props.inputId}-${k}`}
                    key={k}
                  >
                    {ValidationMsg[props.type][k]}
                  </div>
                );
              }
            }
          }
          return null;
        })}
    </div>
  );
}

function getInputValidationCls(valid: ?Validation) {
  if (valid && valid.success === "success") {
    return "input-valid";
  } else if (valid && valid.success === "fail") {
    return "input-error";
  } else {
    return "";
  }
}

function getInputType(type: string) {
  if (type === "email" || type === "text" || type === "password") {
    return type;
  } else if (["istrade", "IsOptIn"].includes(type)) {
    return "checkbox";
  } else if (type === "accountnumber") {
    return "tel";
  } else {
    return "text";
  }
}
